var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 56,
    viewBox: "0 0 44 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 19.6V14C35.75 6.16 29.7 0 22 0C14.3 0 8.25 6.16 8.25 14V19.6C3.575 19.6 0 23.24 0 28V47.6C0 52.36 3.575 56 8.25 56H35.75C40.425 56 44 52.36 44 47.6V28C44 23.24 40.425 19.6 35.75 19.6ZM13.75 14C13.75 9.24 17.325 5.6 22 5.6C26.675 5.6 30.25 9.24 30.25 14V19.6H13.75V14ZM25.025 37.8L24.75 38.08V42C24.75 43.68 23.65 44.8 22 44.8C20.35 44.8 19.25 43.68 19.25 42V38.08C17.6 36.4 17.325 33.88 18.975 32.2C20.625 30.52 23.1 30.24 24.75 31.92C26.4 33.32 26.675 36.12 25.025 37.8Z",
    fill: "#0197D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a80019d154738a2d1adad55905b91976.svg";
export { ForwardRef as ReactComponent };